export const NOTIFICATION_TYPES = {
  AI_CHAT: 'ai_chat',
  REGULAR: 'regular',
  ATTENDANCE: 'attendance',
  NOTICE: 'notice',
  TUTOR: 'tutor'

} 

export const TutorType = {
  MATH: 'math',
  ENGLISH: 'english'
}

export const MessageExportSourceType= {
  CHAT: 'chat',
  BULK_REPORT: 'bulk_report',
  STUDENT_REPORT: 'student_report',
  REPORT: 'report'
}

export const IMAGE_STYLES = {
  MAX_HEIGHT: 250,
  BORDER_RADIUS: '6px',
  // other image-related constants
};

export const UserTypes = {
  ADMIN: 6,
  TEACHER: 0,
  PRINCIPAL: 2,
  STUDENT: 1,
  OFFICE: 3,
  HM: 4,
  VICE_PRINCIPAL: 5,
  ALUMNI: 7,
  BUS_STAFF: 8
}

export const Urls = {
  LANDING_PAGE: 'https://schooline.in',
  
}

export const adminUserTypes = [UserTypes.PRINCIPAL,UserTypes.VICE_PRINCIPAL,UserTypes.HM,UserTypes.ADMIN]

